import React from 'react';
import { MenuItem } from '@mui/material';
import { SearchOutlined as SearchIcon, RefreshOutlined as RefreshIcon } from '@mui/icons-material';
import type { PhysicalCountFilterState } from '../../../types/physicalCount.types';
import {
  ListPageFilterContainer,
  ListPageFilterRow,
  ListPageMainSearchField,
  ListPageFilterTextField,
  ListPageFilterToolbarOutlinedButton,
  ListPageFilterToolbarSearchButton,
  ListPageActiveFilters,
} from '../../common/list-page';
import { usePhysicalCountFilters } from './PhysicalCountFilters.hooks';

export interface PhysicalCountFiltersProps {
  filters: PhysicalCountFilterState;
  setFilters: React.Dispatch<React.SetStateAction<PhysicalCountFilterState>>;
  appliedFilters: PhysicalCountFilterState;
  onClearAppliedField: (field: keyof PhysicalCountFilterState) => void;
  onSearch: () => void;
  onReset: () => void;
  locations: Array<{ id: number; name: string }>;
}

const PhysicalCountFilters: React.FC<PhysicalCountFiltersProps> = ({
  filters,
  setFilters,
  appliedFilters,
  onClearAppliedField,
  onSearch,
  onReset,
  locations = [],
}) => {
  const { handleChange, handleKeyDown, handleReset, handleSearch, activeFilterChips } =
    usePhysicalCountFilters({
      filters,
      setFilters,
      appliedFilters,
      onClearAppliedField,
      onSearch,
      onReset,
      locations,
    });

  return (
    <ListPageFilterContainer>
      <ListPageFilterRow sx={{ flexWrap: 'wrap' }}>
        <ListPageMainSearchField
          label="Código de sesión"
          name="code"
          value={filters.code}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder="Ej: CONTE-2025-001"
        />
        <ListPageFilterTextField
          select
          variant="outlined"
          size="medium"
          label="Sucursal"
          name="locationId"
          value={filters.locationId}
          onChange={(e) => setFilters((prev) => ({ ...prev, locationId: e.target.value }))}
          InputLabelProps={{ shrink: true }}
          SelectProps={{ displayEmpty: true }}
          sx={{ minWidth: 180 }}
        >
          <MenuItem value="">Todas</MenuItem>
          {locations.map((loc) => (
            <MenuItem key={loc.id} value={String(loc.id)}>
              {loc.name}
            </MenuItem>
          ))}
        </ListPageFilterTextField>
        <ListPageFilterToolbarOutlinedButton
          variant="outlined"
          size="medium"
          onClick={handleReset}
          startIcon={<RefreshIcon />}
        >
          Reiniciar
        </ListPageFilterToolbarOutlinedButton>
        <ListPageFilterToolbarSearchButton
          variant="contained"
          size="medium"
          onClick={handleSearch}
          startIcon={<SearchIcon />}
        >
          Buscar
        </ListPageFilterToolbarSearchButton>
      </ListPageFilterRow>

      <ListPageActiveFilters chips={activeFilterChips} />
    </ListPageFilterContainer>
  );
};

export default PhysicalCountFilters;
